import * as THREE from 'three';
import { Buses } from './Buses';

export type AudioDebugSnapshot = {
  unlocked: boolean;
  ctxState: AudioContextState;
  graphs: 1;
  howler: false;
  placeholder: boolean;
};

export type DsAudioHost = {
  audio?: AudioDebugSnapshot;
};

/** One Web Audio graph on THREE.AudioListener. */
export class AudioEngine {
  readonly listener: THREE.AudioListener;
  readonly ctx: AudioContext;
  readonly buses: Buses;
  private _unlocked = false;
  private _placeholder = false;
  private debugHost: DsAudioHost | null = null;

  constructor(camera: THREE.Object3D, hook?: DsAudioHost) {
    this.listener = new THREE.AudioListener();
    camera.add(this.listener);
    this.ctx = this.listener.context;
    this.listener.gain.disconnect();
    this.buses = new Buses(this.ctx);
    this.listener.gain.connect(this.buses.sfx);
    this.buses.master.connect(this.ctx.destination);
    if (hook) {
      this.attachDebug(hook);
    }
  }

  get unlocked(): boolean {
    return this._unlocked;
  }

  get placeholder(): boolean {
    return this._placeholder;
  }

  setPlaceholder(on: boolean): void {
    this._placeholder = on;
    this.publishDebug();
  }

  async unlock(): Promise<void> {
    if (this.ctx.state !== 'running') {
      await this.ctx.resume();
    }
    this._unlocked = this.ctx.state === 'running';
    this.publishDebug();
  }

  attachDebug(ds: DsAudioHost): void {
    this.debugHost = ds;
    this.publishDebug();
  }

  private publishDebug(): void {
    if (!this.debugHost) {
      return;
    }
    this.debugHost.audio = {
      unlocked: this._unlocked,
      ctxState: this.ctx.state,
      graphs: 1,
      howler: false,
      placeholder: this._placeholder,
    };
  }
}

export function attachDebug(ds: DsAudioHost, engine: AudioEngine): void {
  engine.attachDebug(ds);
}
